import * as Yup from "yup";
export const emailSchema = Yup.string()
  .email("Please enter a valid email.")
  //this regex checks if at the end of the email there is a dot and at least one (non-dot) character after it
  .matches(/.*\.[^.]+$/, "Please enter a valid email.")
  .required("Email is required.");
